import { actionTypes } from "./actionTypes";

export const fetchProviderErpInvoices = () => ({
  type: actionTypes.FETCH_PROVIDER_ERP_INVOICES,
});

export const setProviderErpInvoices = (data) => ({
  type: actionTypes.SET_PROVIDER_ERP_INVOICES,
  data,
});

export const setProviderErpInvoicesLoading = (loading) => ({
  type: actionTypes.SET_PROVIDER_ERP_INVOICES_LOADING,
  loading,
});

export const setProviderErpInvoicesError = (error) => ({
  type: actionTypes.SET_PROVIDER_ERP_INVOICES_ERROR,
  error,
});
